import { RemirrorJSON } from 'remirror'

import { generateHtmlFromJSON } from '@pepper/docs/src/utils/functions/htmlGeneratorFromJSON'
import '@pepper/docs/src/styles/editor.css'

import { ReactComponent as LoaderIcon } from 'assets/images/loader.svg'

import styles from './_.module.css'

interface Props {
  isLoading: boolean
  content: RemirrorJSON | undefined
}

const TemplateContent: React.FC<Props> = ({ isLoading, content }) => {
  if (isLoading) {
    return (
      <div>
        <div className={styles.loaderIconContainer}>
          <LoaderIcon className={styles.loaderIcon} />
        </div>
        <div>Please wait while we load the Template..</div>
      </div>
    )
  }

  return (
    <div
      dangerouslySetInnerHTML={{ __html: generateHtmlFromJSON(content) }}
      className={styles.templateHTML}
    />
  )
}

export default TemplateContent
